// JavaScript Document
//components/configuration/SettingIntervalStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import AddIcon from '@material-ui/icons/AddCircle';
//import EditIcon from '@material-ui/icons/Edit';
//import DoneIcon from '@material-ui/icons/Done'
import Popover from '@material-ui/core/Popover';

//import TextField from '@material-ui/core/TextField';
//import MenuItem from '@material-ui/core/MenuItem';
//import PowerInterval from '../configuration/PowerInterval';
//import DisplayModeStandard from '../configuration/DisplayModeStandard';
import Setting from './Setting';
import PowerPicker from '../forms/PowerPicker';
import dsutils from './Utils';
const utils = dsutils();
//const Modes = require('../configuration/StandardModes');

const useStyles = makeStyles((theme) => ({

	interval : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 330,
		minWidth: 165,
	},
	intervalEdit : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 350,
		minWidth: 285
	},
	settingInput : {
		margin: theme.spacing(1),
		width: 90
	},
	settingInputText : {
		textAlign: 'center'
	},
	editButton : {
		textAlign: 'center',
		flexGrow: 1,
		width: '100%'
	},
	modeLabel: {
		textAlign: 'center',
		marginRight: theme.spacing(1)
	},
	chip : {
			margin: theme.spacing(0.5),
			//fontSize:'0.9em'
		},
	
}));

export default function SettingIntervalStandard(props) {
  const classes = useStyles();
	//Inherited props
	//sign = sign object
	//config = config object
	//settings = eachSetting & intervals
	//onChange = inherited handler for making changes
	//id = group id to use in onChange handler
	//enableAdd = bool whether new intervals can be added
  	const {sign, config, settings, onChange, id, enableAdd, displays} = props;

	//State variables that can be updated independent of inherited props
	const [addable, setAddable] = React.useState(true);
	const [groupSettings, setGroupSettings] = React.useState(utils.model.settingGroup);
	const [intervals, setIntervals] = React.useState([]);
	//const [edit, setEdit] = React.useState(false);
  	//const [token, setToken] = React.useState(null);
	
	//Popover state
	const [popper, setPopper] = React.useState({
		anchor: null,
		open : false,
		interval : []
	});
	
	//update state on props changes
  	React.useEffect(() => {
		//Only update if loading new daysetting
		setIntervals(settings.intervals);
		setGroupSettings(settings);
		//console.log("Inherited id "+id);
		if(enableAdd === false){
			setAddable(false);
		} else {
			setAddable(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//update settings handler
	const handleSettingUpdate = (gsettings) => {
		//apply intervals
		gsettings.intervals = intervals;
		//update local group settings
		setGroupSettings(gsettings);
		if(onChange){
			onChange(id, gsettings);
		}
	}
  
	
	//Add interval Handler
	const handleAddInterval = (interval) => {
		let newIntervals = utils.control.interval.insert(interval, intervals);
		//update local
		setIntervals(newIntervals);
		let newGroupSettings = Object.assign({}, groupSettings);
		newGroupSettings.intervals = newIntervals;
		//update parent, if available
		if(onChange){
			onChange(id, newGroupSettings);
		} else {
			setGroupSettings(newGroupSettings);
		}
		closePopper();
  	};
	
	//Remove interval handler
	const handleDelInterval = (e, ikey) => {
		let newIntervals = Object.assign([], intervals);
		//remove the interval
		newIntervals.splice(ikey, 1);
		//update local intervals
		setIntervals(newIntervals);
		let newGroupSettings = Object.assign({}, groupSettings);
		newGroupSettings.intervals = newIntervals;
		//we can add a new interval now
		setAddable(true);
		//update parent, if available
		if(onChange){
			onChange(id, newGroupSettings);
		} else {
			setGroupSettings(newGroupSettings);
		}
	};
	
	//Open Interval Popper
	const addInterval = (e) => {
		let times = [];
		if(intervals.length > 0){
			times.push(intervals[intervals.length - 1][1]);
			times.push(times[0]);
			console.log(times);
		}
		setPopper({
			anchor: e.currentTarget,
			open:true,
			interval: times
		});
	};
	
	//Close interval popper
	const closePopper = () => {
		setPopper({
			anchor: null,
			open : false,
			interval : []
		});
	}
	
	//Compile the add interval chip
	const addChip = () => {
		if(addable){
			return (
				<Chip size="medium"
					color="secondary"
					label="Add"
					variant="outlined"
					icon={<AddIcon />}
					onClick={addInterval}
					className={classes.chip}
				/>
			);
		} else {
			return "";
		}
	}
	
	//extract the display text for an interval
	const displayText = (interval) => {
		return utils.control.time.pretty(interval[0])+' - '+utils.control.time.pretty(interval[1]);
	}
	

  	return (
		<Setting sign={sign} config={config} settings={groupSettings} onChange={handleSettingUpdate} displays={displays}>
			{intervals.map((row, x) => (
				<Chip
					size="medium"
					color="secondary"
					key={x}
					id={x}
					label={displayText(row)}
					onDelete={(e) => {handleDelInterval(e, x)}}
					className={classes.chip}
				/>
			))}
			{addChip()}
			<Popover
					id={id+'_intervalpopper'}
					open={popper.open}
					anchorEl={popper.anchor}
					onClose={closePopper}
					anchorOrigin={{
								  vertical:'bottom',
								  horizontal: 'center'
								 }}
					transformOrigin={{
									 vertical:'top',
									 horizontal:'center'
									}}
				>
				<PowerPicker times={popper.interval} onChange={handleAddInterval} intervals={intervals} />
			</Popover>
		</Setting>
  	);

}
